﻿//our root app component
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
declare var jQuery: any;
@Component({
    selector: 'date-picker',
    template: '<input #element name=[name] />',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: DatePickerComponent,
        multi: true
    }]
})
export class DatePickerComponent implements ControlValueAccessor {
    constructor() { }
    @Input() public name = '';
    @Input() public show24HourTime: boolean = false;
    @ViewChild("element", { read: ElementRef }) element: ElementRef;

    onChange;

    ngOnInit() {
        var format = 'M d, Y h:i a';
        var formatTime = 'h:i a';
        if (this.show24HourTime) {
            format = "M d, Y H:i";
            formatTime = 'H:i';
        }
        jQuery.datetimepicker.setLocale('en');
        jQuery(this.element.nativeElement).datetimepicker({
                closeOnTimeSelect: true,
                controlType: 'select',
                oneLine: true,
                step:30,
                format: format,
                formatTime: formatTime,
            onSelectDate: (value) => {
                this.onChange(value);
            },
            onSelectTime: (value) => {
                this.onChange(value);
            }
        });
    }

    writeValue(value) {
        this.element.nativeElement.textContent = value;
    }

    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { }
}